import { SortByContext } from "context/ViewContext/SortByContext";
import { useProviderInitializedContext } from "./useProviderInitializedContext";

export const useSortBy = () => {
  return useProviderInitializedContext(SortByContext);
};
